import {getPlayerSession} from '@/api/api';
import {SessionSummary} from '@/api/MLSChallenge/useGetPlayerAppointments';
import {useQuery} from '@tanstack/react-query';

export type GetPlayerSessionParams = {clientId?: string | null; siteId?: number | null; sessionId?: string | null};

export type SessionData = {
  baselineLevel: string;
  totalBallsFired: number;
  repetitions: number;
  isBaselineSession: boolean;
  startTime: string;
  sessionSummary: SessionSummary['session'];
  exercises: SessionSummary['exercises'];
  sessionName?: string;
  isV3Session: boolean;
};

export const useGetPlayerSession = ({sessionId, clientId, siteId}: GetPlayerSessionParams) => {
  return useQuery<SessionData>({
    queryKey: ['player-session', clientId, siteId, sessionId],
    queryFn: () => getPlayerSession({clientId, siteId, sessionId}),
    enabled: !!clientId && !!siteId && !!sessionId,
  });
};
